const url = new URL(window.location.href);
const SERVER_PORT = 80;
export const GET_OTC_MARKET_STATUS = `/api/v1/market/market-status`;
export const OTC_ORDER_INIT = `/api/v1/financial-coordinator/otc/order/init`;
export const GET_ASSETS_PRICE_OTC_TICKER = `/api/v1/market/otc/ticker`;
export const GET_OTC_CHART_DATA = `/api/v1/market/otc/kline`;
export const GET_ASSETS_LIST_SELECTOR = `/api/v1/market/selectors`;
export const SOCKET_SERVER = import.meta.env.VITE_WEBSOCKET_SOCKET_SERVER || '';
